module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN209_655803815.30ded991.png";